import 'ol/ol.css';
import { Map, View } from 'ol';
import Tile from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import { Fill, Style, Text, Stroke } from 'ol/style';
import { transform } from 'ol/proj';
import VectorTileSource from 'ol/source/VectorTile';
import VectorTile from 'ol/layer/VectorTile';
import MVT from 'ol/format/MVT';
import Overlay from 'ol/Overlay';

/**
 * Styles
 */
var styles = [];
styles[1] = new Style({
  fill: new Fill({
    color: '#75F515'
  }),
  text: new Text(),
  stroke: new Stroke({
    color: 'rgba(200, 200, 200, 1)',
    width: 1,
  })
});
styles[2] = new Style({
  fill: new Fill({
    color: '#D2EB49'
  }),
  text: new Text(),
  stroke: new Stroke({
    color: 'rgba(200, 200, 200, 1)',
    width: 1,
  })
});
styles[3] = new Style({
  fill: new Fill({
    color: '#EBE913'
  }),
  text: new Text(),
  stroke: new Stroke({
    color: 'rgba(200, 200, 200, 1)',
    width: 1,
  })
});
styles[4] = new Style({
  fill: new Fill({
    color: '#F2A327'
  }),
  text: new Text(),
  stroke: new Stroke({
    color: 'rgba(200, 200, 200, 1)',
    width: 1,
  })
});
styles[5] = new Style({
  fill: new Fill({
    color: '#FA0014'
  }),
  text: new Text(),
  stroke: new Stroke({
    color: 'rgba(200, 200, 200, 1)',
    width: 1,
  })
});
styles[6] = new Style({
  fill: new Fill({
    color: 'rgba(255, 255, 255, 0.01)'
  }),
  text: new Text()
});
var selectedStyle = new Style({
  stroke: new Stroke({
    color: 'rgba(200, 200, 200, 1)',
    width: 2,
  })
});

/**
 * Layers
 */
const vectorLayers = [];
vectorLayers[0] = new Tile({ source: new OSM() });
vectorLayers[1] = new VectorTile({
  source: new VectorTileSource({
    format: new MVT(),
    url: 'http://cadastresolaire.developpement.top:8090/1/{z}/{x}/{y}.pbf'
  }),
  style: styles[1]
});
vectorLayers[2] = new VectorTile({
  source: new VectorTileSource({
    format: new MVT(),
    url: 'http://cadastresolaire.developpement.top:8090/2/{z}/{x}/{y}.pbf'
  }),
  style: styles[2]
});
vectorLayers[3] = new VectorTile({
  source: new VectorTileSource({
    format: new MVT(),
    url: 'http://cadastresolaire.developpement.top:8090/3/{z}/{x}/{y}.pbf'
  }),
  style: styles[3]
});
vectorLayers[4] = new VectorTile({
  source: new VectorTileSource({
    format: new MVT(),
    url: 'http://cadastresolaire.developpement.top:8090/4/{z}/{x}/{y}.pbf'
  }),
  style: styles[4]
});
vectorLayers[5] = new VectorTile({
  source: new VectorTileSource({
    format: new MVT(),
    url: 'http://cadastresolaire.developpement.top:8090/5/{z}/{x}/{y}.pbf'
  }),
  style: styles[5]
});
vectorLayers[6] = new VectorTile({
  source: new VectorTileSource({
    format: new MVT(),
    url: 'http://cadastresolaire.developpement.top:8090/0/{z}/{x}/{y}.pbf'
  }),
  style: styles[6]
});

/**
 * Popup
 */
var container = document.getElementById('popup');
var content = document.getElementById('popup-content');
var closer = document.getElementById('popup-closer');

closer.onclick = function() {
  overlayClick.setPosition(undefined);
  closer.blur();
  return false;
};

var overlayClick = new Overlay({
  element: container,
  autoPan: true,
  autoPanAnimation: {
    duration: 250
  }
});

/**
 * Map
 */
const map = new Map({
  target: 'map',
  layers: vectorLayers,
  view: new View({
    center: transform([-6.8524944, 33.9979168], 'EPSG:4326', 'EPSG:3857'),
    zoom: 16,
    maxZoom: 18,
    minZoom: 12,
  }),
  overlays: [overlayClick]
});
window.map = map;
window.transform = transform;

 // Selection
 var selection = {};
var  vectorLayer = new VectorTile({
    map: map,
    renderMode: 'vector',
    source: vectorLayers[6].getSource(),
    style: function (feature) {
      if (feature.getId() in selection) {
        return selectedStyle;
      }
    },
  });
map.on(['click'], function (event) {
  overlayClick.setPosition(undefined);
  vectorLayers[6].getFeatures(event.pixel).then(function (features) {
    if (!features.length) {
      selection = {};
      vectorLayer.changed();
      return;
    }
    var feature = features[0];
    if (!feature) {
      return;
    }
    var fid = feature.getId();
    selection = {};
    selection[fid] = feature;
    vectorLayer.changed();

    // Popup
    var properties = feature.getProperties() ;
    var coordinate = event.coordinate;
    content.innerHTML = `
                          <div class="bg-white shadow overflow-hidden">

                          <div class="px-4 py-5 sm:px-6 text-center my-4">
                              <h3 class="text-lg leading-6 font-montserrat font-semibold text-color-3 mb-2">
                              Cadastre Solaire Maroc
                              </h3>
                              <p class="mt-1 text-sm font-Montserrat font-normal text-color-2 mx-auto px-8">
                                Le cadastre solaire est une carte d’un territoire qui met en avant l’énergie solaire qui arrive sur les toitures sur une année moyenne.
                                Des couleurs différentes permettent de mettre en avant plusieurs niveaux d’ensoleillement afin de savoir quelles sont les toitures qui peuvent accueillir des panneaux solaires.
                              </p>
                          </div>

                          <div class="mx-10 pl-4">
                            <table class="table-fixed w-full mb-8">
                              <thead>
                                <tr>
                                  <th class="w-1/3 px-4 py-2"></th>
                                  <th class="w-1/3 px-4 py-2"></th>
                                  <th class="w-1/3 px-4 py-2"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="px-4 py-2">
                                    <img class="h-12" src="images/icon-map-l1.png" alt="Type de support	">
                                  </td>
                                  <td class="px-4 py-2">
                                    <img class="h-12" src="images/icon-map-l2.png" alt="Surface en m">
                                  </td>
                                  <td class="px-4 py-2">
                                    <img class="h-12" src="images/icon-map-l3.png" alt="Irradiation solaire">
                                  </td>
                                </tr>
                                <tr>
                                  <td class="px-4 py-2 text-color-4 font-montserrat font-medium text-sm">
                                    Type de support
                                  </td>
                                  <td class="px-4 py-2 text-color-4 font-montserrat font-medium text-sm">
                                    Surface
                                  </td>
                                  <td class="px-4 py-2 text-color-4 font-montserrat font-medium text-sm">
                                    Irradiation solaire
                                  </td>
                                </tr>
                                <tr>
                                  <td class="px-4 py-2 text-color-5 font-semibold">Toiture</td>
                                  <td class="px-4 py-2 text-color-5 font-semibold">${properties.area} m²</td>
                                  <td id="prop_gsi_color" class="px-4 py-2 font-semibold"><span id="prop_gsi">${properties.gsi}</span> kWh/m²/an</td>
                                </tr>
                                <tr>
                                  <td class="px-4 py-2 text-color-4 font-montserrat font-normal text-sm">
                                    Toiture, parking en surface (couvert potentiel).
                                  </td>
                                  <td class="px-4 py-2 text-color-4 font-montserrat font-normal text-sm"></td>
                                  <td class="px-4 py-2 text-color-4 font-montserrat font-normal text-sm"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div class="mb-10 text-center">
                          <a href="${properties.rapport}" target="rapport" class="py-4 px-6 text-center bg-el-right rounded-full text-gray-100 text-md hover:opacity-75 focus:outline-none">Télécharger le rapport</a>
                          </div>
                      </div>
                        `;
    overlayClick.setPosition(coordinate);

    function integerColor() {
        var proGsi = parseInt(document.getElementById("prop_gsi").textContent);
        var proGsiColor = document.getElementById("prop_gsi_color");
        if (proGsi > 0 & proGsi < 1100) {
            proGsiColor.style.color = 'rgb(51, 204, 51)';
        } else if (proGsi > 1101 & proGsi < 1200) {
            proGsiColor.style.color = 'rgb(7, 176, 117)';
        } else if (proGsi > 1201 & proGsi < 1300) {
            proGsiColor.style.color = 'rgb(240, 222, 38)';
        } else if (proGsi > 1301 & proGsi < 1399) {
            proGsiColor.style.color = 'rgb(240, 175, 8)';
        } else if (proGsi > 1400) {
            proGsiColor.style.color = 'rgb(230, 82, 77)';
        } else {
            proGsiColor.style.color = 'rgb(230, 82, 77)';
        }
    }
    integerColor();
  });

});
